import { InferGetStaticPropsType } from 'next'

/* blocks */
import Index25PageTemplate from '@/cmp/templates/Index25/Index25PageTemplate'
import Layout from '@/cmp/templates/Layout/Index25Layout'

/* utils */
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import { TEN_MINS_REVALIDATION } from '@/utils/constants/revalidation'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'
import {
  index25PageQuery,
  Index25PageResponse
} from '@/utils/queries/index-25/index_25'

function Index25Page({ page }: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <Layout
      title="Index'25"
      meta={constructMetadataFromStrapiData(page.seo)}
      canonical={`/index-25/`}
    >
      <Index25PageTemplate data={page} />
    </Layout>
  )
}

export const getStaticProps = async () => {
  const result = await getStrapiGraphqlData<Index25PageResponse>(
    index25PageQuery.loc?.source.body
  )

  return {
    props: {
      page: result.page.data.attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export default Index25Page
